import columns from '../../../../../../react-table/helpers/columns';

export default (data) => {
  const {
    TextColumn,
    NonZeroNumberColumn,
    DateTimeColumn,
    ExternalDespatchLinkColumn,
  } = columns(data);

  return [
    {
      Header: 'Origin IMPC',
      columns: [
        new TextColumn('Operator', 'originImpc.operator'),
        new TextColumn('Code', 'originImpc.code'),
      ],
    },
    {
      Header: 'Destination IMPC',
      columns: [
        new TextColumn('Operator', 'destinationImpc.operator'),
        new TextColumn('Code', 'destinationImpc.code'),
      ],
    },
    {
      Header: 'PREDES',
      columns: [
        new ExternalDespatchLinkColumn(new TextColumn('Despatch ID', 'predes.despatchId').withWidth(200)),
        new DateTimeColumn('Despatch closed', 'predes.despatchCloseDate'),
        new DateTimeColumn('Planned departure', 'predes.plannedDepartureDate'),
        new DateTimeColumn('Planned arrival', 'predes.plannedArrivalDate'),
      ],
    },
    {
      Header: 'First scan - Planned arrival',
      columns: [
        new NonZeroNumberColumn('d', 'firstScanVsPlanning.missedDay'),
        new NonZeroNumberColumn('h', 'firstScanVsPlanning.missedHour'),
        new NonZeroNumberColumn('m', 'firstScanVsPlanning.missedMinute'),
      ],
    },
    {
      Header: 'RESDES',
      columns: [
        new DateTimeColumn('First scan', 'resdes.firstScanDate'),
      ],
    },
    {
      Header: 'Tail',
      columns: [
        new NonZeroNumberColumn('d', 'tail.missedDay'),
        new NonZeroNumberColumn('h', 'tail.missedHour'),
        new NonZeroNumberColumn('m', 'tail.missedMinute'),
      ],
    },
    {
      Header: 'RESDES',
      columns: [
        new DateTimeColumn('Last scan', 'resdes.lastScanDate'),
      ],
    },
    {
      Header: 'Receptacles',
      columns: [
        new NonZeroNumberColumn('PREDES', 'receptacles.predes'),
        new NonZeroNumberColumn('RESDES', 'receptacles.resdes'),
      ],
    },
  ];
};
